const constants = {
  transitionBase: 'all 250ms ease-in',
};

export default constants;
